import * as i18n from "util/i18n";
import * as config from "util/config";

const Mustache = require("mustache");

export const getMinMax = () => {
    const minLength = config.getInteger("core.password.minLength");
    const maxLength = config.getInteger("core.password.maxLength");
    const minLengthValidationMsg = Mustache.render(i18n.get("onboarding.password.validation.minLength"), {
        minLength,
        maxLength,
    });
    const maxLengthValidationMsg = Mustache.render(i18n.get("onboarding.password.validation.maxLength"), {
        maxLength,
    });
    return { minLength, maxLength, minLengthValidationMsg, maxLengthValidationMsg };
};

const validations = [
    {
        description: i18n.get("onboarding.password.validation2", "Mínimo 1 minúscula"),
        status: (password) => {
            if (!password) {
                return "INITIAL";
            }
            return /[a-z]/.test(password) ? "DONE" : "WRONG";
        },
    },
    {
        description: i18n.get("onboarding.password.validation1", "Mínimo 1 mayúscula"),
        status: (password) => {
            if (!password) {
                return "INITIAL";
            }
            return /[A-Z]/.test(password) ? "DONE" : "WRONG";
        },
    },
    {
        description: i18n.get("onboarding.password.validation3", "Mínimo 1 número"),
        status: (password) => {
            if (!password) {
                return "INITIAL";
            }
            return /\d/.test(password) ? "DONE" : "WRONG";
        },
    },
    {
        description: i18n.get("onboarding.password.validation4", "Mínimo 1 de los siguientes símbolos @$#!%&()_+{}?*"),
        status: (password) => {
            if (!password) {
                return "INITIAL";
            }
            const symbols = /[@$#¡!%&()_{}?¿*]/;
            return symbols.test(password) ? "DONE" : "WRONG";
        },
    },
];

const notContainValidations = [
    {
        description: i18n.get("onboarding.password.validation5", "Más de 2 caracteres repetidos. Ej: AA"),
        status: (password) => {
            if (!password) {
                return "INITIAL";
            }
            return /([a-zA-Z])\1/.test(password) ? "WRONG" : "DONE";
        },
    },
    {
        description: i18n.get("onboarding.password.validation6", "Más de 3 caracteres consecutivos. Ej: 1234 o abcd"),
        status: (password) => {
            if (!password) {
                return "INITIAL";
            }
            return /(0123|1234|2345|3456|4567|5678|6789|abcd|bcde|cdef|defg|efgh|fghi|ghij|hijk|ijkl|jklm|klmn|lmnñ|mnño|nñop|ñopq|opqr|pqrs|qrst|rstu|stuv|tuvw|uvwx|vwxy|wxyz)+/.test(
                password,
            )
                ? "WRONG"
                : "DONE";
        },
    },
];

export const getItems = (password) =>
    validations.map((val) => ({ status: val.status(password), description: val.description }));

export const getNotContainItems = (password) =>
    notContainValidations.map((val) => ({
        status: val.status(password),
        description: val.description,
    }));

export const passwordStrength = (password) => {
    const numInvalidValidations = validations.reduce(
        (invalids, val) => (val.status(password) !== "DONE" ? invalids + 1 : invalids),
        0,
    );
    const numInvalidNotContainValidations = notContainValidations.reduce(
        (invalids, val) => (val.status(password) !== "DONE" ? invalids + 1 : invalids),
        0,
    );

    const totalNumInvalidValidations = numInvalidValidations + numInvalidNotContainValidations;

    if (totalNumInvalidValidations === 0) {
        return 67;
    }

    if (totalNumInvalidValidations <= 1) {
        return 34;
    }

    if (password) {
        return 1;
    }

    return -1;
};

export const submitIsDisabled = ({ firstValidation, password, repeatedPassword }) => {
    const firstValidationWrong = firstValidation.status(password) !== "DONE";

    const numInvalidValidations = validations.reduce(
        (invalids, val) => (val.status(password) !== "DONE" ? invalids + 1 : invalids),
        0,
    );
    const numInvalidNotContainValidations = notContainValidations.reduce(
        (invalids, val) => (val.status(password) !== "DONE" ? invalids + 1 : invalids),
        0,
    );

    const totalNumInvalidValidations = numInvalidValidations + numInvalidNotContainValidations;
    const repeatedPasswordIsDifferent = repeatedPassword !== password;

    return firstValidationWrong || totalNumInvalidValidations > 0 || repeatedPasswordIsDifferent;
};
